import apiClient from "@/lib/api/api-client";
import { env } from "@/config/env";

export interface ResendVerificationRequest {
  email: string;
}

export interface ResendVerificationResponse {
  message: string;
}

export async function resendVerification(payload: ResendVerificationRequest) {
  const { data } = await apiClient.post<ResendVerificationResponse>(
    env.authResendVerificationPath,
    payload,
  );
  return data;
}
